/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScanStatus } from './ScanStatus';
import {
    ScanStatusFromJSON,
    ScanStatusFromJSONTyped,
    ScanStatusToJSON,
} from './ScanStatus';

/**
 * 
 * @export
 * @interface ScanStatusCount
 */
export interface ScanStatusCount {
    /**
     * 
     * @type {number}
     * @memberof ScanStatusCount
     */
    count: number;
    /**
     * 
     * @type {ScanStatus}
     * @memberof ScanStatusCount
     */
    status: ScanStatus;
}



/**
 * Check if a given object implements the ScanStatusCount interface.
 */
export function instanceOfScanStatusCount(value: object): value is ScanStatusCount {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function ScanStatusCountFromJSON(json: any): ScanStatusCount {
    return ScanStatusCountFromJSONTyped(json, false);
}

export function ScanStatusCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScanStatusCount {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'status': ScanStatusFromJSON(json['status']),
    };
}

export function ScanStatusCountToJSON(value?: ScanStatusCount | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'status': ScanStatusToJSON(value['status']),
    };
}

